import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Box,
  VStack,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

// Create a CustomModal component that accepts data and displays two cards
const CustomModal = ({ isOpen, onClose, data }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            {/* First Card - Horizontal */}
            <Box
              w="100%"
              p={4}
              bg="gray.100"
              borderRadius="md"
              boxShadow="md"
              display="flex"
              flexDirection="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <h3>Card 1 Title</h3>
                <p>{data.card1Content}</p>
              </Box>
              {/* Add more content in the first card as needed */}
            </Box>

            {/* Second Card - Vertical */}
            <Box
              w="100%"
              p={4}
              bg="gray.100"
              borderRadius="md"
              boxShadow="md"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
            >
              <h3>Card 2 Title</h3>
              <p>{data.card2Content}</p>
              {/* Add more content in the second card as needed */}
            </Box>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.shape({
    card1Content: PropTypes.string,
    card2Content: PropTypes.string,
  }).isRequired,
};

export default CustomModal;
